'use strict';

module.exports = function() {
    var args = Array.prototype.slice.call(arguments);
    return new Promise(function(resolve) {
        setTimeout.apply(null, [resolve].concat(args));
    });
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/timeout-as-promise/index.js
// module id = 70
// module chunks = 0